export enum DocumentsDBIndexType {
    Key = 'key',
    Fulltext = 'fulltext',
    Unique = 'unique',
}
